module.exports.Directive = function() {
    return {
      restrict: "E",
      scope: {},
      templateUrl: "/modules/common/footer-component/footer-component.view.html"
    };
  };
  